/* ---------------------------------------------------
	共通js用
 ----------------------------------------------------- */
$('#popup-iframe').magnificPopup({
		disableOn: 812,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 200,
		preloader: false,
		fixedContentPos: false
});

$(function() {
	// checkbox, radio にチェックがあったら label に class を付ける
	var checkboxList = $(".p-form__radio");
	checkboxList.each(function() {
		var label = $(this).find("label");
		// 最初の処理
		$(this).find(":checked").closest("label").addClass("checked");
		// ラベルクリック
		label.click(function() {
			label.filter(".checked").removeClass("checked");
			label.find(":checked").closest(label).addClass("checked");
		});
	});
});